// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RjMG","index":"styles_index__3omzo"};